import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getClinicDetail() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/clinic`;
    return httpGet(apiUrl);
  }

  updateClinicDetail(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/clinic`;
    return httpPut(apiUrl, data);
  }

  uploadClinicFile(upload, type) {
    let formData = new FormData();
    formData.append("clinicFile", upload);

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/clinic/file?fileType=${type}`;

    return httpUploadFormData(apiUrl, formData);
  }

  deleteClinicFile(type) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/clinic/file?fileType=${type}`;

    return httpDelete(apiUrl);
  }

  getClinicFileList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/clinic/file`;

    return httpGet(apiUrl);
  }
}
